import { inject } from "vue";

import { JssipManager } from "@/packages/vue-jssip/jssip";

export function useJssip() {
  const $jssip = inject("$jssip") as JssipManager;

  return $jssip;
}
